import { render } from "./DonateSuccess.vue?vue&type=template&id=2b7b94ef"
import script from "./DonateSuccess.vue?vue&type=script&lang=js"
export * from "./DonateSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__